import { render, staticRenderFns } from "./BSearcher.vue?vue&type=template&id=2f1ed8e2&scoped=true&"
import script from "./BSearcher.vue?vue&type=script&lang=js&"
export * from "./BSearcher.vue?vue&type=script&lang=js&"
import style0 from "./BSearcher.vue?vue&type=style&index=0&id=2f1ed8e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1ed8e2",
  null
  
)

export default component.exports